/**
 * @file コンポーネント：スライダー ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import { fnSetFixedBody } from "~/src/functions/common";

// コンポーネントを返す
export const Slider = (props) => {
    /**
     * スライド位置
     */
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        if (Number.isInteger(props.defaultIndex) && props.defaultIndex >= 0) {
            setCurrentIndex(props.defaultIndex);
        }
    }, [props.defaultIndex]);

    /**
     * ズーム機能
     */
    const [isZoom, setIsZoom] = useState(false);
    useEffect(() => {
        fnSetFixedBody(isZoom);
    }, [isZoom]);

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            currentIndex={currentIndex}
            isZoom={isZoom}
            setCurrentIndex={setCurrentIndex}
            setIsZoom={setIsZoom}
        />
    );
};
